module.exports = __webpack_public_path__ + "img/pause.02b69ca2.svg";